<template>
  <svg
    :class="customClass"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M7 17 17 7" />
    <polyline points="7 7 17 7 17 17" />
  </svg>
</template>

<script>
export default {
  name: "ArrowUpRight",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
  },
};
</script>
